module.exports = __webpack_public_path__ + "static/media/Teil_2.32c7ae16.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_2.mp4
// module id = 113
// module chunks = 0